import './icon.scss'

export default (props) => 
<span className={`icon ${props.className || ''}`}
    style={{WebkitMaskImage: `url(https://static.tui.com/assets/v2/icons/tui-light/${props.icon}.svg)`, maskImage: `url(https://static.tui.com/assets/v2/icons/tui-light/${props.icon}.svg)`, color:`${props.color  || "currentColor"} `}}>
</span>